
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import AgendaSettings from '@/components/agenda/AgendaSettings';
import { useLanguage } from '@/contexts/LanguageContext';
import { useIsMobile } from '@/hooks/use-mobile';

interface AgendaHeaderProps {
  isSidebarHidden: boolean;
  toggleSidebarVisibility: () => void;
  timezone: string;
  showWeekends: boolean;
  toggleWeekends: () => void;
  resetCalendar: () => void;
  eventsInView: number;
  formatCurrentTimezoneTime: () => string;
  firstDay: number;
  handleFirstDayChange: (day: number) => void;
  slotMinTime: string;
  handleSlotMinTimeChange: (time: string) => void;
  slotMaxTime: string;
  handleSlotMaxTimeChange: (time: string) => void;
  eventTextColor: string;
  handleEventTextColorChange: (color: string) => void;
  currentView: string;
  viewDateRange: { start: string; end: string } | null;
  onYearChange: (delta: number) => void;
}

const AgendaHeader: React.FC<AgendaHeaderProps> = ({
  isSidebarHidden,
  toggleSidebarVisibility,
  timezone,
  showWeekends,
  toggleWeekends,
  resetCalendar,
  eventsInView,
  formatCurrentTimezoneTime,
  firstDay,
  handleFirstDayChange,
  slotMinTime,
  handleSlotMinTimeChange,
  slotMaxTime,
  handleSlotMaxTimeChange,
  eventTextColor,
  handleEventTextColorChange,
  currentView,
  viewDateRange,
  onYearChange
}) => {
  const { t } = useLanguage();
  const isMobile = useIsMobile();

  /*if (isMobile) {
    return null; // Ne rend rien si l'utilisateur est sur mobile
  }*/

  return (
    <div className="flex flex-col md:flex-row md:items-center justify-between mb-4 md:mb-6 gap-2">
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-2">
          <AgendaSettings
            isFullscreen={isSidebarHidden}
            onToggleFullscreen={toggleSidebarVisibility}
            showWeekends={showWeekends}
            onToggleWeekends={toggleWeekends}
            onResetCalendar={resetCalendar}
            firstDay={firstDay}
            onFirstDayChange={handleFirstDayChange}
            slotMinTime={slotMinTime}
            onSlotMinTimeChange={handleSlotMinTimeChange}
            slotMaxTime={slotMaxTime}
            onSlotMaxTimeChange={handleSlotMaxTimeChange}
            eventTextColor={eventTextColor}
            onEventTextColorChange={handleEventTextColorChange}
            currentView={currentView}
            viewDateRange={viewDateRange}
            onYearChange={onYearChange}
          />
          <Badge variant="outline" className="font-normal">
            {eventsInView} {t('agenda.eventsInView')}
          </Badge>
          {/*<TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <Badge variant="secondary" className="font-normal">
                  {timezone}
                </Badge>
              </TooltipTrigger>
              <TooltipContent className="p-2">
                <p>
                  {t('agenda.currentTime')}: {formatCurrentTimezoneTime()}
                </p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>*/}
        </div>
      </div>
    </div>
  );
};

export default AgendaHeader;
